<div class="app__main-wrapper" *ngIf="!isLoggingOut">
  <div class="app__main-container">
    <div class="app__content-container">
      <ng-container *ngIf="isLoggedIn && !isArrivalRoute">
        <router-outlet></router-outlet>
      </ng-container>

      <ng-container *ngIf="!isLoggedIn">
        <router-outlet></router-outlet>
      </ng-container>

      <div class="app__footer--push"></div>
    </div>
  </div>
</div>
